import React from "react";

import { Box } from "../../layout";
import {
  BOTTOM_NAVBAR_DEFAULT_HEIGHT,
  BOTTOM_NAVBAR_IOS_APP_HEIGHT
} from "../consts";
import MobileNavbar from "../MobileNavbar";
import { MobileNavbarItemProps } from "../MobileNavbarItem/MobileNavbarItem";

type Props = {
  children: {
    page: React.ReactNode;
    navbarItems: React.ReactElement<MobileNavbarItemProps>[];
  };
  isiOSApp?: boolean;
};

export default function PageWithBottomNavbar({
  children: { page, navbarItems },
  isiOSApp
}: Props) {
  const height = isiOSApp
    ? BOTTOM_NAVBAR_IOS_APP_HEIGHT
    : BOTTOM_NAVBAR_DEFAULT_HEIGHT;

  return (
    <Box>
      <Box
        dataTest="bottom-navbar"
        position="fixed"
        bottom="0"
        left="0"
        width="100%"
        zIndex={2}
      >
        <MobileNavbar height={height}>{navbarItems}</MobileNavbar>
      </Box>
      {page}
      <Box height={height} />
    </Box>
  );
}
